import { render, staticRenderFns } from "./RecipeAddPage.vue?vue&type=template&id=3ba22948&"
import script from "./RecipeAddPage.vue?vue&type=script&lang=js&"
export * from "./RecipeAddPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports